import React from 'react';
import './applycredit.scss'
import Icon_Tick from '../../../../assets/images/Icon_Tick.svg'
import { IProps, IQuantityColumnProps } from './applycreditinterface'
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { DataTable } from '../../../CommonComponent';
import Alerts from '../../../Alerts';
import helperfunctions from "../../../../utils/helperfunctions";
import Loader from '../../../Loader';

const QuantityColumn: React.FC<IQuantityColumnProps> = ({ creditInput, onIncrement, onDecrement, onCreditInputChange }) => {

    const displayedValue = `$${creditInput}`;
    return (
        // <td><input className="quantity_input" type="number"/></td>
        <div className="quantity-value">
            <span onClick={() => onDecrement()} onKeyDown={() => { }} className="quantity_minus">-</span>
            <input className="textfield" placeholder=""
                value={displayedValue}
                onChange={(e) => {
                    const numericValue = e.target.value.replace(/\$/g, '');
                    onCreditInputChange(numericValue)
                }}
            />
            <span onClick={() => onIncrement()} onKeyDown={() => { }} className="quantity_plus">+</span>
        </div>
    )
}

const Applycredit = (props: IProps) => {
    const { t } = useTranslation();
    const eligibleCredit = props?.popUpInfo?.eligibleCredit ?? 0;
    const subTotal = props?.popUpInfo?.subTotal ?? 0;
    const balanceCredit = props?.applyCreditResponse?.data?.remainingCreditBalance ?
        props?.applyCreditResponse?.data?.remainingCreditBalance : '0'
    const remainingCreditBalance = helperfunctions.formatAmount(balanceCredit);
    const isDisableContinue = !(props?.isCreditApplied);
    const oneTimeCreditRemaining = props?.applyCreditResponse?.data?.oneTimeCreditRemaining ?? 0;
    const isShowWarning = (props?.applyCreditResponse?.data.hasOwnProperty('isValid') && props?.applyCreditResponse?.data?.isValid === false);
    return (
        <div className='applycredit_wrapper'>
            {(props?.continuePartsCreditResponse?.loading || props?.applyCreditResponse?.loading || props?.availablePartsCredits?.loading) && <Loader />}
            <div className='applycrdit_labels'>
                {t(RESOURCE.MyK_Label_ShoppingCart_Apply_Komatsu_Credit)}
                <span className='ml-2 creditavailable'>
                    (${props?.availableCreditAmount} {t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Available)})</span>
            </div>
            <div className='applycredit_content mt-2'>
                <QuantityColumn
                    creditInput={props?.creditInput}
                    onIncrement={() => props?.incrementCount()}
                    onDecrement={() => props?.decrementCount()}
                    onCreditInputChange={props?.onCreditInputChange}
                />
                <span className='applybutton'>
                    <button className='primarybutton' onClick={() => props?.onApplyPartsCredit()}>{t(RESOURCE.MyK_Label_ShoppingCart_Apply)}</button>
                </span>
                {
                    props?.applyCreditResponse?.data?.isSuccess &&
                    <span className='creditbadge_wrapper'>
                        <p className="CreditappliedBadge">
                            <img src={Icon_Tick} alt="tick icon" className="TickIcon me-1" />
                            {t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Applied)}</p>
                    </span>
                }
            </div>
            {props?.popUpInfo?.errMsg && <div className='mt-2'>
                <Alerts
                    messageAlert={props?.popUpInfo?.errMsg}
                    alertType={'error'}
                    onClose={() => { props?.onCloseAlert() }}
                />
            </div>}
            {
                isShowWarning && <div className='mt-2'>
                    <Alerts
                        messageAlert={`${t(RESOURCE.MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg1)} $${helperfunctions.formatAmount(oneTimeCreditRemaining)} ${t(RESOURCE.MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg2)}.`}
                        alertType={'error'}
                        onClose={() => { }}
                    />
                </div>
            }
            <div className='mt-2'>
                <span className='applycrdit_labels'>{t(RESOURCE.MyK_Label_ShoppingCart_Sub_Total)}:</span>
                <span className='ml-2'>${helperfunctions.formatAmount(subTotal)}</span>
            </div>
            <div className='mt-3'>
                <span className='fa fa-info-circle'></span>
                <span className='applycrdit_labels'>{t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Eligible)}:</span>
                <span className='ml-2'>${helperfunctions.formatAmount(eligibleCredit)}</span>
            </div>
            {
                props?.applyCreditResponse?.data?.isSuccess && <div className='mt-3'>
                    <span className='applycrdit_labels'>{t(RESOURCE.MyK_Label_ShoppingCart_Remaining_Komatsu_credit_Balance)}:</span>
                    <span className='ml-2'>${remainingCreditBalance}</span>
                </div>}
            {
                props?.creditList?.data?.length > 0 &&
                <div className='mt-3'>
                    <DataTable
                    storageKey={"applyCredit"} enableFiltering={true}
                        getSelectedValue={props?.getSelectedValue}
                        selection={true}
                        dataColumn={props?.creditTableColumn}
                        data={props?.creditList?.data ?? []}
                        dataItemKey="creditEntryIdGroup"
                        isSelect={false}
                        selectedCredit={props?.selectedCreditInfo}
                    />
                </div>
            }

            <div className='mt-3'>
                <div className='footerbuttons'>
                    <button disabled={isDisableContinue} className={`primarybutton mr-2 ${isDisableContinue ? 'disabled' : ''}`} onClick={() => props.onContinuePartsCredit()}>{t(RESOURCE.MyK_Label_ShoppingCart_Continue)}</button>
                    <button className='secondarybutton' onClick={() => {
                        props?.applyOnClick();
                        props?.updateApplyCreditRes({ loading: false, data: {} })
                    }
                    }>{t(RESOURCE.MyK_Label_Cancel)}</button>
                </div>
            </div>
        </div>
    )
}

export default Applycredit